import { useEffect, useState } from 'react';

type OptimisticApplyStatus = 'applied' | 'unapplied' | null;

export const useOptimisticApplyStatus = (
  assignmentId: number | null | undefined,
  isAlreadyApplied: boolean,
) => {
  const [optimisticApplyStatus, setOptimisticApplyStatus] = useState<OptimisticApplyStatus>(null);

  useEffect(() => {
    setOptimisticApplyStatus(null);
  }, [assignmentId]);

  const isAppliedOrPreApply =
    optimisticApplyStatus === 'applied' ||
    (optimisticApplyStatus !== 'unapplied' && isAlreadyApplied);

  return { isAppliedOrPreApply, setOptimisticApplyStatus };
};
